module.exports = __webpack_public_path__ + "img/flash-pay.93ce075d.svg";